import {
    LOGIN_LOADING,
    LOGIN_SUCCESS,
    LOGIN_ERROR,
    SIGNUP_START,
    SIGNUP_SUCCESS,
    SIGNUP_ERROR,
  } from "./constants";
import {getToken} from '../../utils/authManager';

  const initialState= {
    token:  getToken() || null,
    loading: false,
    errorMessage: {},
    validating: false,
    signupData: null
  };
  
  export function authReducer(
    state = initialState,
    action
  ){
    switch (action.type) {
      case LOGIN_LOADING:
          return {
            ...state,
            loading: action.payload
          };
      case LOGIN_ERROR:
          return {
            ...state,
            errorMessage: action.payload
          };
      case LOGIN_SUCCESS:
          return {
            ...state,
            token: action.payload
          };
      case SIGNUP_START:
        return {
          ...state,
          loading: true,
        };
      case SIGNUP_SUCCESS:
        return {
          ...state,
          signupData: action.payload,
          loading: false,
        };
      case SIGNUP_ERROR:
        return {
          ...state,
          errorMessage: action.payload,
          loading: false,
        };
      default:
        return state;
    }
  }
  